import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Estimulación Temprana'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48260170875050:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48260172021930:1'
  };
  const plans = {
    megapack: {
      emoji: '👶',
      name: 'MEGAPACK ESTIMULACIÓN TEMPRANA',
      desc: '6 tomos + 6 bonos · Sistema completo 0 a 36 meses',
      priceOld: '$58.990',
      priceNew: '$19.990',
      priceColor: 'text-gray-900',
      cta: '→ SÍ, QUIERO EL MEGAPACK',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK + GUÍA DE NEURODESARROLLO AVANZADO',
      desc: 'Todo el Megapack + protocolo avanzado de estimulación neurológica.',
      priceOld: '$102.990',
      priceNew: '$27.990',
      priceColor: 'text-purple-700',
      cta: '→ SÍ, QUIERO EL MEGAPACK COMPLETO',
      sub: '6 tomos · 6 bonos · Neurodesarrollo Avanzado · Acceso inmediato'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(243,232,255) 0%, rgb(253,244,255) 15%, rgb(253,244,255) 85%, rgb(243,232,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-192">
      <div className="mx-auto max-w-3xl" data-id="element-193">

        {/* ── HEADING ── */}
        <div className="text-center mb-8" data-id="element-194">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-4" style={{
          color: '#7c3aed',
          border: '1px solid rgba(124,58,237,0.40)',
          background: 'rgba(124,58,237,0.05)'
        }} data-id="element-195">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-196">
            Elegí tu{' '}
            <span style={{
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-197">
              Megapack:
            </span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-198">
            Las dos opciones incluyen los 6 bonos exclusivos completos
          </p>
        </div>

        {/* ── PLAN SELECTOR ── */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-199">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className="w-full text-left rounded-xl p-4 transition-all cursor-pointer" style={{
            border: isSelected ? '2px solid #7c3aed' : '1px solid rgb(229,231,235)',
            backgroundColor: isSelected ? 'rgba(124,58,237,0.04)' : 'rgb(255,255,255)',
            boxShadow: isSelected ? '0px 0px 30px 0px rgba(124,58,237,0.15)' : '0 1px 2px rgba(0,0,0,0.05)'
          }} data-id="element-200">
                <div className="flex items-center gap-3" data-id="element-201">
                  {/* Radio */}
                  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2" style={{
                borderColor: isSelected ? '#7c3aed' : 'rgb(209,213,219)'
              }} data-id="element-202">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full" style={{
                  background: '#7c3aed'
                }} data-id="element-203" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-204">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-205">
                      <span data-id="element-206">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-207">
                        {p.name}
                      </span>
                      {plan === 'megapack-pro' && <span className="text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
                    background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)'
                  }} data-id="element-208">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-209">{p.desc}</p>
                  </div>

                  {/* Price */}
                  <div className="shrink-0 text-right" data-id="element-210">
                    <div className="text-xs text-gray-400 line-through" data-id="element-211">
                      {p.priceOld}
                    </div>
                    <div className={`text-2xl font-black ${p.priceColor}`} data-id="element-212">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* ── CTA BLOCK ── */}
        <div className="rounded-2xl p-5 shadow-lg" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
      }} data-id="element-213">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-4" data-id="element-214">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-215">
                <span className="text-white/60" data-id="element-216">✓</span> {item}
              </span>)}
          </div>
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Neurodesarrollo Avanzado' : 'Megapack Estimulación Temprana',
          content_category: 'Estimulación Temprana',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full bg-white text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline transition-colors hover:opacity-90" style={{
          color: '#7c3aed'
        }} data-id="element-217">
            {active.cta}
          </a>
          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-218">
            Más de 2.400 madres ya estimulan a sus hijos con un sistema real
          </p>
        </div>

        {/* ── TRUST BADGES ── */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-3 shadow-sm" style={{
        border: '1px solid rgba(168,85,247,0.15)'
      }} data-id="element-219">
          <span data-id="element-220">🔒 Pago seguro</span>
          <span data-id="element-221">⚡ Acceso en 5 min</span>
          <span data-id="element-222">🛡️ Garantía 7 días</span>
          <span data-id="element-223">💳 Mercado Pago</span>
        </div>

      </div>
    </section>;
}